/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SbSharedRefineMenuInputRangeCurrency_searchBrowse$ref = any;
type SbSharedRefineMenuPriceRanges_searchBrowse$ref = any;
type SbSharedRefineMenuSaleInput_searchBrowse$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SbRespRefineMenuFilterPrice_searchBrowse$ref: FragmentReference;
export type SbRespRefineMenuFilterPrice_searchBrowse = {|
  +$fragmentRefs: SbSharedRefineMenuPriceRanges_searchBrowse$ref & SbSharedRefineMenuInputRangeCurrency_searchBrowse$ref & SbSharedRefineMenuSaleInput_searchBrowse$ref,
  +$refType: SbRespRefineMenuFilterPrice_searchBrowse$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SbRespRefineMenuFilterPrice_searchBrowse",
  "type": "SearchBrowseQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuPriceRanges_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuInputRangeCurrency_searchBrowse",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuSaleInput_searchBrowse",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '1028b3787babbe29aa598d3af690c808';
module.exports = node;
